import React from "react";
import useNewsletterConfirmation, { NEWSLETTER_CONFIMRATION_SUCCESS } from "./useNewsletterConfirmation";
import "./style.scss";
import ConfettiAnimation from "../PurchaseSuccess/ConfettiAnimation";
import EAButton from "../shared/Buttons/EAButton";

const NON_CONFIRMED_TITLE = "Potwierdź zapis do newslettera";
const CONFIRMED_TITLE = "🚀 Zapisałeś się do naszego newslettera.";

const NewsletterConfirmation: React.FC = () => {
  const { status, onConfirm } = useNewsletterConfirmation();

  return (
   
      <div className="newsletter-form-container-new">
      {status === NEWSLETTER_CONFIMRATION_SUCCESS && <ConfettiAnimation />}

      <div className="newsletter-form-box-new">
        <h1 className="newsletter-form-title">
          {status === NEWSLETTER_CONFIMRATION_SUCCESS ? CONFIRMED_TITLE : NON_CONFIRMED_TITLE}
        </h1>

      <p>
      Dziękujemy za zapisanie się do naszego newslettera! Aby potwierdzić subskrypcję i otrzymywać informacje prosimy o
            kliknięcie przycisku „Potwierdź” poniżej.
      </p>


      




        {/* {facilityIds === "1228" &&  <span className="newsletter-form-body">
          <p>
            {" "}
            Dziękujemy za zapisanie się do naszego newslettera! Aby potwierdzić subskrypcję i otrzymywać informacje o
            naszych wydarzeniach specjalnych, ciekawostkach popularnonaukowych oraz nowościach w ofercie, prosimy o
            kliknięcie przycisku „Potwierdź” poniżej.
          </p>

          <b>
            Drogi kliencie, Twój adres email został zapisany w naszej bazie danych. W celu zalogowania się należy
            kliknąć nie pamiętam hasła.
          </b>
          <p>
            Do zobaczenia! Zespół Centrum Popularyzacji Nauki i Innowacji Uniwersytetu Warmińsko-Mazurskiego w Olsztynie
            KORTOSFERA
          </p>
        </span>} */}

        {status !== NEWSLETTER_CONFIMRATION_SUCCESS && <EAButton title="Potwierdź" onClick={onConfirm} />}
      </div>
      </div>
 
  );
};

export default NewsletterConfirmation;
